import { createAction } from '@reduxjs/toolkit';
export const FETCH_CHAT_ASSISTANT_QUOTA = 'FETCH_CHAT_ASSISTANT_QUOTA';
export const fetchChatAssistantQuotaAction = createAction(FETCH_CHAT_ASSISTANT_QUOTA);